export default "__VITE_ASSET__79c8234a__"